export default __webpack_public_path__ + "static/media/notifications.fe2448f3.md";